import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { BillingSidebar } from '@/components/billing/BillingSidebar';
import { BillingTopBar } from '@/components/billing/BillingTopBar';
import { BreadcrumbProvider } from '@/components/common/BreadcrumbContext';

const BillingLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <BreadcrumbProvider>
      <div className="fixed inset-0 flex overflow-hidden bg-background text-foreground">
        <BillingSidebar collapsed={collapsed} />

        <div className="flex min-w-0 flex-1 flex-col">
          <BillingTopBar onToggleSidebar={() => setCollapsed((c) => !c)} />

          {/* overscroll-contain: this is the app's scroll container, and without
            it the leftover scroll at either end is handed to the document,
            moving the entire shell. */}
          <main className="flex-1 overflow-auto overscroll-contain px-4 py-4">
            <Outlet />
          </main>

          <footer className="flex flex-wrap items-center justify-between gap-2 border-t border-border bg-card px-4 py-2 text-[11px] text-muted-foreground">
            <span>
              AdvisorKhoj MIS CRM · v0.1.0 ·{' '}
              <span className="font-semibold text-foreground">DEV</span> · © 2026 AdvisorKhoj
            </span>
            <a href="mailto:support@advisorkhoj.com" className="hover:text-foreground">
              support@advisorkhoj.com
            </a>
          </footer>
        </div>
      </div>
    </BreadcrumbProvider>
  );
};

export default BillingLayout;
